import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../../utils/network-call/network-call";

export const CompanyAdminProjectModulesLoader = async (args: LoaderFunctionArgs) => {
    const getProjectResponse = await networkCall(`/projects/${ args.params.id }`);
    return { id: args.params.id, getProjectResponse };
};